import { Box, Button, Popover, PopoverProps, TextField, Tooltip, Typography } from '@material-ui/core'
import React, { useContext, useEffect } from 'react'
import { useState } from 'react'

import CactusIcon from 'mdi-material-ui/Cactus'
import { keyboard } from '../../input/keyboard'
import { GamePageContext } from '../Game/GamePage'
import { TAB_ICONS } from './NodeInventory'

type NodeSearchProps = { nodes: any[] } & PopoverProps

export default function NodeSearch({ tab = '', nodes, children, open, onClick = undefined as any, ...rest }: { tab: string } & NodeSearchProps) {

	const { gameContainer } = useContext(GamePageContext)

	const [residualNodes, setResidualNodes] = useState(nodes)

	const [filterText, setFilterText] = useState('')

	const [selectedIndex, setSelectedIndex] = useState(0)

	const filterNodes = residualNodes.filter(node => {
		return (
			node.name.includes(filterText) ||
			node.desc.includes(filterText)
		)
	})

	useEffect(() => {
		if (nodes.length) {
			setResidualNodes(nodes)
		}
	}, [nodes])

	useEffect(() => {
		if (open && !nodes.length) {
			setResidualNodes(nodes)
		}
		if (open) {
			setFilterText('')
			setSelectedIndex(0)
		}
	}, [open, nodes])


	return (
		<Popover
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'right',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}

			open={open}
			style={{
				marginTop: 8,
			}}
			disableScrollLock
			container={gameContainer}
			{...rest}
		>
			<Box display="flex" flexDirection="column" gridGap="16px" p="8px">
				<TextField
					autoFocus
					placeholder="Search nodes..."
					value={filterText}
					onChange={e => {
						setFilterText(e.target.value)
						setSelectedIndex(0)
					}}
					variant="outlined"
					size="small"
					InputProps={{
						startAdornment: tab ? (
							<Box paddingRight="8px"><Typography color="primary">{tab}:</Typography></Box>
						) : undefined
					}}
					onKeyDown={(event: any) => {
						if (keyboard.ctrlDown) {
							if (event.key === 'e' || event.key === 'p') {
								event.stopPropagation()
								event.preventDefault()

								onClick(filterNodes[selectedIndex])
							}
						}

						if (event.key === 'Enter') {
							onClick(filterNodes[selectedIndex])
							event.stopPropagation()
						} else if (event.key === 'ArrowUp') {
							const nIndex = (selectedIndex - 1) >= 0 ? (selectedIndex - 1) : (filterNodes.length - 1)
							setSelectedIndex(nIndex)
							event.preventDefault()
							event.stopPropagation()
						} else if (event.key === 'ArrowDown') {
							const nIndex = (selectedIndex + 1) < filterNodes.length ? (selectedIndex + 1) : 0
							setSelectedIndex(nIndex)
							event.preventDefault()
							event.stopPropagation()
						} else if (event.key === 'Tab') {
							const nIndex = (selectedIndex + 1) < filterNodes.length ? (selectedIndex + 1) : 0
							setSelectedIndex(nIndex)
							event.preventDefault()
							event.stopPropagation()
						}
					}}
				/>
				{filterNodes.length ? (
					<>
						<Typography color="primary"><b>{filterNodes[selectedIndex].name}</b></Typography>
						<Box display="grid" gridGap="12px" gridAutoFlow="row" gridTemplateColumns="repeat(4, 1fr)">
							{filterNodes.map((node, index) => {
								const isSelected = index === selectedIndex

								const CategoryIcon = TAB_ICONS.find(([category]) => category === (node.category || 'All'))?.[1] as any

								return (
									<Box key={node.name} width="60px" display="flex" flexDirection="column" gridGap="8px" position="relative">
										<Tooltip title={
											<Box display="flex" flexDirection="column">
												<Typography align="center">
													<Box component="span" fontSize="12px">
														<b>{node.name}</b>
													</Box>
												</Typography>
												<Typography align="center">
													<Box component="span" fontSize="12px">
														{node.desc}
													</Box>
												</Typography>
											</Box>
										}>
											<Button
												onClick={() => onClick(node)}

												color={isSelected ? "primary" : undefined}
												variant="contained"
												disableElevation

												style={{ padding: 8, minWidth: 0, minHeight: 0, width: 60, height: 60 }}
											>
												<Box
													position="relative"
													fontSize="24px"
													fontFamily="Segoe UI Emoji"
												>
													{node.symbol}
												</Box>
											</Button>
										</Tooltip>

										<Box position="absolute" top="0" right="0" display="flex" width="14px" height="14px" alignItems="center" justifyContent="center" m="4px">
											{Boolean(CategoryIcon) && <CategoryIcon style={{ fontSize: 14 }} />}
										</Box>
									</Box>
								)
							})}
						</Box>
					</>
				) : (
					<Box display="flex" alignItems="center" gridGap="8px" color="text.secondary">
						<Typography>No Matches...</Typography>
						<CactusIcon />
					</Box>
				)}
			</Box>
		</Popover>
	)
}
